import { UiManager } from '../../ui/ui.manager';
import { PanZoomManager } from '../../pan-zoom/pan-zoom.manager';
import { EditableEvent } from '../editable-event';
import { ImageController, initPictureFlags } from './image-controller';
import { FrameController } from '../frame/frame-controller';
import { EditableSideTool } from '../editable-side-tool';
import { ImageEditableTool } from './image-editable-tool';
import { LayoutDataManager } from '../../data/layout-data.manager';
import * as createjs from 'createjs-module';
import { CjBitmap, CjContainer, CjShape } from '../../../model/cj-factory';
import { IconPosition, CjFocusHandleIcon, SIDE_POSITIONS, CORNER_POSITIONS, SidePosition, isSidePosition } from '../../../model/cj-factory/cj-focus-handle-icon';
import { CjTool } from '../../../../utilities/cj-tool';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME, CJ_FOCUS_NAME } from '../../../model/cj-factory/cj-obj-name.collection';
import { FocusModeType } from '../../data/layout-data-type';
import { EditableImageManager } from '../../editable-image/editable-image.manager';
import { FitChecker } from '../../../../utilities/fit-checker';
import { EditableImage } from '../editable-image';
import { PosManager } from '../../pos/pos.manager';
import { Pos } from '../../../../models/pos';
import { ImageEditManager } from '../image-edit.manager';
import { TextEvent } from '../text/text-event';
import { TrimmingManager } from '../../trimming/trimming.manager';
import { SmartGuideManager } from '../../smart-guide/smart-guide.manager';

export type TargetType = {
  id: string,
  photoId: string,
  pos: { x: number, y: number },
  scale: { x: number, y: number },
  reg: { x: number, y: number },
  rotation: number,
  wrapperScale: number,
}

export class ImageEvent {
  private stage: CjContainer;

  private editableImageManager!: EditableImageManager;
  private panZoomManager!: PanZoomManager;
  private imageController!: ImageController;
  private frameController!: FrameController;
  private editableEvent!: EditableEvent;
  private editableSideTool!: EditableSideTool;
  private imageEditableTool!: ImageEditableTool;
  private layoutDataManager!: LayoutDataManager;
  private posManager!: PosManager;
  private imageEditManager!: ImageEditManager;
  private textEvent!: TextEvent;
  private trimmingManager!: TrimmingManager;
  private smartGuideManager!: SmartGuideManager;

  private clicked: boolean = false;
  private transformed: boolean = false;
  activeFocus: CjContainer | null = null;
  targetFrame: CjContainer | null = null;
  isFocus: boolean = false;
  isExchange: boolean = false;
  isSelect: boolean = true;
  isMove: boolean = false;
  private isFastMove: boolean = true;
  private showToolTip: boolean = false;
  private checkCounter: number = 0;
  private delayNum: number = 2;
  frameMoveMode: boolean = true;
  focusHandleIcon: CjFocusHandleIcon | null = null;
  dragTarget: CjContainer | null = null;
  private dragPointX: number = 0;
  private dragPointY: number = 0;
  private iconPosition: IconPosition = 'lt';
  private movingTarget: CjContainer | null = null;
  private previewImage: createjs.Bitmap | null = null;
  private timerId: NodeJS.Timeout | undefined;

  targetData: TargetType = {
    id: '',
    photoId: '',
    pos: { x: 0, y: 0 },
    scale: { x: 0, y: 0 },
    reg: { x: 0, y: 0 },
    rotation: 0,
    wrapperScale: 0,
  };

  imageInitData: {
    target: CjContainer,
    param: {
      x: number,
      y: number,
      movePos: { x: number, y: number },
      rotation: number,
      scaleX: number,
      scaleY: number,
      regX: number,
      regY: number,
    },
  }[] = [];

  constructor(stage: CjContainer) {
    this.stage = stage;
  }

  di(
    imageController: ImageController,
    frameController: FrameController,
    panZoomMng: PanZoomManager,
    editableEvent: EditableEvent,
    editableSideTool: EditableSideTool,
    imageEditableTool: ImageEditableTool,
    layoutDataManager: LayoutDataManager,
    editableMng: EditableImageManager,
    posMng: PosManager,
    imageEditMng: ImageEditManager,
    textEvent: TextEvent,
    trimmingMng: TrimmingManager,
    smartGuideMng: SmartGuideManager,
  ): void {
    this.frameController = frameController;
    this.imageController = imageController;
    this.panZoomManager = panZoomMng;
    this.editableEvent = editableEvent;
    this.editableSideTool = editableSideTool;
    this.imageEditableTool = imageEditableTool;
    this.layoutDataManager = layoutDataManager;
    this.editableImageManager = editableMng;
    this.posManager = posMng;
    this.imageEditManager = imageEditMng;
    this.textEvent = textEvent;
    this.trimmingManager = trimmingMng;
    this.smartGuideManager = smartGuideMng;
  }

  initialize() {
  }

  destroy() {
    this.clicked = false;
    this.transformed = false;
    this.activeFocus = null;
    this.targetFrame = null;
    this.isFocus = false;
    this.isFastMove = true;
    this.isMove = false;
    this.frameMoveMode = true;
    this.focusHandleIcon = null;
    this.dragPointX = 0;
    this.dragPointY = 0;
    this.iconPosition = 'lt';
    this.movingTarget = null;
    this.previewImage = null;
    this.imageInitData.length = 0;
  }

  update(stage: CjContainer): void {
    this.stage = stage;
  }

  // - 選択時の枠の四隅のアイコン作成 -
  async createCorner(
    imageBounds: createjs.Rectangle,
    type: FocusModeType,
  ): Promise<(CjFocusHandleIcon | CjShape)[]> {
    return new Promise((resolve) => {
      const Icons = [];
      if (type === 'scale') {
        Icons.push(new CjFocusHandleIcon('scale', 'rt', imageBounds));
        Icons.push(new CjFocusHandleIcon('scale', 'rb', imageBounds));
        Icons.push(new CjFocusHandleIcon('scale', 'lb', imageBounds));
        Icons.push(new CjFocusHandleIcon('scale', 'lt', imageBounds));
      } else if (type === 'rotate' || type === 'png') {
        Icons.push(new CjFocusHandleIcon('scale', 'rt', imageBounds));
        Icons.push(new CjFocusHandleIcon('rotate', 'rb', imageBounds));
        Icons.push(new CjFocusHandleIcon('scale', 'lb', imageBounds));
        Icons.push(new CjFocusHandleIcon('rotate', 'lt', imageBounds));
      } else {
        const size = 5;
        const positions = [
          { x: imageBounds.x + imageBounds.width, y: imageBounds.y },
          { x: imageBounds.x + imageBounds.width, y: imageBounds.y + imageBounds.height },
          { x: imageBounds.x, y: imageBounds.y + imageBounds.height },
          { x: imageBounds.x, y: imageBounds.y },
        ];
        for (const pos of positions) {
          const circle = new CjShape();
          circle.graphics.f('#A5B9F4').dc(0, 0, size);
          circle.x = pos.x;
          circle.y = pos.y;
          Icons.push(circle);
        }
      }
      for (const icon of Icons) {
        icon.name = CJ_FOCUS_NAME.corner;
      }
      resolve(Icons);
    });
  }

  // - 選択時の枠の辺中央のアイコン作成 -
  async createSideIcon(
    imageBounds: createjs.Rectangle,
  ): Promise<CjFocusHandleIcon[]> {
    return new Promise((resolve) => {
      const Icons: CjFocusHandleIcon[] = [];
      Icons.push(new CjFocusHandleIcon('scale', 't', imageBounds));
      Icons.push(new CjFocusHandleIcon('scale', 'r', imageBounds));
      Icons.push(new CjFocusHandleIcon('scale', 'b', imageBounds));
      Icons.push(new CjFocusHandleIcon('scale', 'l', imageBounds));
      for (const icon of Icons) {
        icon.name = CJ_FOCUS_NAME.side;
      }
      resolve(Icons);
    });
  }

  // - 選択時の枠作成 -
  async createFocus(image: CjContainer, focusMode: FocusModeType, hasSideIcons: boolean = false) {
    let bounds = image.getBounds();
    // -- コンテナとシェイプ用意 --
    const container: CjContainer = new CjContainer();
    switch (focusMode) {
      case 'scale':
        container.name = CJ_CONTAINER_NAME.focus.scale;
        break;
      case 'rotate':
        const photo = await CjTool.checkLoad(image.getChildByName(CJ_DPOBJ_NAME.image) as CjBitmap);
        bounds = photo.getTransformedBounds();
        container.name = CJ_CONTAINER_NAME.focus.rotate;
        break;
      case 'png':
        container.name = CJ_CONTAINER_NAME.focus.rotate;
        break;
      case 'move' || 'none':
        container.name = CJ_CONTAINER_NAME.focus.move;
        break;
      default:
        break;
    }
    // -- 枠線用意 --
    const isDashed = focusMode !== 'scale' && focusMode !== 'rotate' && focusMode !== 'png';
    const color = '#A5B9F4';
    const baseStroke = 3.5;
    const createFocusLine = (name: string, draw: (g: createjs.Graphics) => void) => {
      const line = new CjShape();
      line.name = name;
      line.isDashed = isDashed;
      const g = line.graphics.clear().s(color).ss(baseStroke);
      if (isDashed) g.sd([10, 5], 0);
      draw(g);
      line.x = bounds.x;
      line.y = bounds.y;
      return line;
    };
    // 横線（上・下）
    const focusH = createFocusLine(CJ_FOCUS_NAME.lineH, (g) => {
      g.mt(0, 0).lt(bounds.width, 0);
      g.mt(0, bounds.height).lt(bounds.width, bounds.height);
    });
    // 縦線（左・右）
    const focusV = createFocusLine(CJ_FOCUS_NAME.lineV, (g) => {
      g.mt(0, 0).lt(0, bounds.height);
      g.mt(bounds.width, 0).lt(bounds.width, bounds.height);
    });
    container.addChild(focusH, focusV);
    // -- 操作ハンドル用意 --
    const cornerIcons = await this.createCorner(bounds, focusMode);
    const sideIcons = hasSideIcons ? await this.createSideIcon(bounds) : [];
    const allIcons = [...cornerIcons, ...sideIcons];
    for (const _icon of allIcons) {
      if (focusMode === 'move') {
        container.addChild(_icon);
      } else {
        const icon = _icon as CjFocusHandleIcon;
        icon.on('mousedown', (e: any) => {
          this.handleTransformStart(image, e);
        });
        if ((focusMode === 'rotate' && (icon.position === 'lt' || icon.position === 'rb'))
          || (focusMode === 'png' && (icon.position === 'lt' || icon.position === 'rb'))) {
          icon.on('pressmove', (e: any) => {
            this.handleRotateMove(image, e, icon.position);
          });
          icon.on('mouseover', (e: any) => {
            if (this.showToolTip) return;
            this.showToolTip = true;
            const pos = this.posManager.canvasToBrowser({
              // container の外側の座標だから container の座標を引いとく
              x: this.stage.stage.mouseX - ImageEditManager.STAGE_CONTAINER_X + 10,
              y: this.stage.stage.mouseY - ImageEditManager.STAGE_CONTAINER_Y + 10,
            });
            UiManager.ins.emit('l->r:show-tooltip',
              { type: 'rotateIcon', pos },
            );
          });
          icon.on('mouseout', (e) => {
            this.showToolTip = false;
            UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          });
        } else {
          icon.on('pressmove', (e: any) => {
            this.handleScaleMove(image, e);
          });
          icon.on('mouseover', (e) => {
            if (this.showToolTip) return;
            this.showToolTip = true;
            const pos = this.posManager.canvasToBrowser({
              // container の外側の座標だから container の座標を引いとく
              x: this.stage.stage.mouseX - ImageEditManager.STAGE_CONTAINER_X + 10,
              y: this.stage.stage.mouseY - ImageEditManager.STAGE_CONTAINER_Y + 10,
            });
            UiManager.ins.emit('l->r:show-tooltip',
              { type: 'scaleIcon', pos },
            );
          });
          icon.on('mouseout', (e) => {
            this.showToolTip = false;
            UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          });
        }
        icon.on('pressup', (e: any) => {
          this.handleTransformEnd(image, e);
        });
        container.addChild(icon);
      }
    }
    return container;
  }

  updateToolPos(focusMode: FocusModeType, target: CjContainer) {
    const isPng = this.layoutDataManager.selector('getFocusMode') === 'png';
    if (isPng) return;
    const defaultContainer = CjTool.getDefaultContainer(target);
    const imageAreaContainer = CjTool.getImageAreaContainer(target);
    const photoContainer = CjTool.getPhotoContainer(target);
    const scaleContainer = CjTool.getScaleContainer(target);
    const rotateContainer = CjTool.getRotateContainer(target);
    const defaultData = defaultContainer.getTransformedBounds();
    const isPhoto = CjTool.checkPhotoInFrame(target);
    const imageContainerData = (focusMode === 'rotate' || focusMode === 'dai') ? imageAreaContainer.getBounds() : undefined;
    const imageContainerTfData = (focusMode === 'rotate' || focusMode === 'dai') ? imageAreaContainer.getTransformedBounds() : undefined;
    const photoContainerData = (focusMode === 'rotate' || focusMode === 'dai') ? photoContainer.getBounds() : undefined;
    const photoContainerTfData = (focusMode === 'rotate' || focusMode === 'dai') ? photoContainer.getTransformedBounds() : undefined;
    const diffFramePos = {
      x: photoContainerTfData ? ((photoContainerTfData.width * scaleContainer.scaleX) - photoContainerTfData.width) / 2 : 0,
      y: photoContainerTfData ? ((photoContainerTfData.height * scaleContainer.scaleX) - photoContainerTfData.height) / 2 : 0,
    };
    if (CjTool.checkPhotoInFrame(target)) {
      photoContainer.rotation = rotateContainer.isRotate
        ? photoContainer.rotation + 90
        : photoContainer.rotation;
    }
    const framePos = CjTool.getFramePos(target);
    let pos: Pos = this.posManager.canvasToBrowser({
      x: (focusMode === 'rotate' || focusMode === 'dai')
        ? imageContainerData!.x + (photoContainerTfData!.x - photoContainer.movePos.x) + imageAreaContainer.movePos.x + (photoContainer.movePos.x * scaleContainer.scaleX) - diffFramePos.x - framePos.x
        : defaultData.x,
      y: (focusMode === 'rotate' || focusMode === 'dai')
        ? imageContainerData!.y - 30 + (photoContainerTfData!.y - photoContainer.movePos.y) + imageAreaContainer.movePos.y + (photoContainer.movePos.y * scaleContainer.scaleX) - diffFramePos.y - framePos.y
        : defaultData.y - 30,
    });
    // 写真枠が回転している場合
    if (focusMode === 'rotate' && rotateContainer.isRotate) {
      pos = this.posManager.canvasToBrowser({
        x: imageContainerData!.x + (photoContainerTfData!.y - photoContainer.movePos.y) - imageAreaContainer.movePos.y - (photoContainer.movePos.y * scaleContainer.scaleX) - diffFramePos.y + framePos.y,
        y: imageContainerData!.y + (photoContainerTfData!.x - photoContainer.movePos.x) + imageAreaContainer.movePos.x + (photoContainer.movePos.x * scaleContainer.scaleX) - diffFramePos.x - framePos.x,
      });
    }
    if (CjTool.checkPhotoInFrame(target)) {
      photoContainer.rotation = rotateContainer.isRotate
        ? photoContainer.rotation - 90
        : photoContainer.rotation;
    }
    UiManager.ins.emit('l->r:select', {
      image: target,
      pos,
      isImgDisabled: focusMode === 'dai' || imageAreaContainer.logoFlag ? true : !Boolean(isPhoto),
    });
  }

  /** フォーカス枠線を表示スケールに合わせて更新 */
  updateFocusLine(
    target: CjContainer,
    targetFocus: CjContainer,
    displayScale: { x: number, y: number },
  ) {
    const lines = CjTool.getFocusLine(targetFocus);
    const { x, y } = displayScale;
    const { width, height } = CjTool.getScaleContainer(target).originalBounds;
    this.updateFocusLines(lines, { w: width * x, h: height * y }, displayScale);
  }

  updateFocusLines(
    lines: CjShape[],
    bounds: { w: number, h: number },
    scale: { x: number, y: number },
    options?: {
      dashed?: boolean;
    },
  ) {
    const {
      dashed = false,
    } = options ?? {};
    for (const line of lines) {
      if (dashed ? !line.isDashed : line.isDashed) continue;
      const g = line.graphics;
      g.clear().s('#A5B9F4').ss(3.5);
      if (dashed) g.sd([10, 5], 0);
      if (line.name === CJ_FOCUS_NAME.lineH) {
        g.mt(0, 0).lt(bounds.w, 0);
        g.mt(0, bounds.h).lt(bounds.w, bounds.h);
      } else if (line.name === CJ_FOCUS_NAME.lineV) {
        g.mt(0, 0).lt(0, bounds.h);
        g.mt(bounds.w, 0).lt(bounds.w, bounds.h);
      }
      line.scaleX = 1 / scale.x;
      line.scaleY = 1 / scale.y;
    }
  }

  /** ハンドルアイコンを表示スケールに合わせて補正 */
  adjustHandleIconScale = (target: CjContainer, icon: CjFocusHandleIcon, iconScaleX: number, iconScaleY: number, isPhoto = false) => {
    const rotContainer = !isPhoto ? CjTool.getRotateContainer(target) : undefined;
    if (rotContainer?.isRotate) [iconScaleX, iconScaleY] = [iconScaleY, iconScaleX];
    const rot = ((icon.rotation ?? 0) + (rotContainer?.isRotate ? 90 : 0)) % 360;
    if (rot === 90 || rot === 270) [iconScaleX, iconScaleY] = [iconScaleY, iconScaleX];
    icon.scaleX = 1 / (iconScaleX);
    icon.scaleY = 1 / (iconScaleY);
  }

  // -- containerのfocus --
  handleFocus(target: CjContainer, focusMode: FocusModeType) {
    // --- すでに表示されているfocusの削除 ---
    this.layoutDataManager.dispatch('setFocusMode', focusMode);
    if (this.textEvent.isFocus && this.textEvent.targetFrame) {
      this.editableEvent.disFocused(this.textEvent.targetFrame);
    }
    if (target !== this.targetFrame) {
      UiManager.ins.emit('l->r:dis-select');
      if (this.targetFrame) {
        this.editableEvent.disFocused(this.targetFrame);
      }
    }
    this.isFocus = true;
    this.targetFrame = target;
    const scaleContainer = CjTool.getScaleContainer(target);
    const rotateContainer = CjTool.getRotateContainer(target);
    const rotateLength = rotateContainer.numChildren;
    let focus;
    switch (focusMode) {
      case 'scale':
        focus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.scale);
        focus.visible = true;
        UiManager.ins.emit('l->r:change-image/frame', { mode: 'image-frame' });
        const imageArea = CjTool.getImageAreaContainer(target);
        imageArea && rotateContainer.setChildIndex(imageArea, rotateLength - 1);
        break;
      case 'rotate':
      case 'dai':
        focus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate);
        focus.visible = true;
        UiManager.ins.emit('l->r:change-image/frame', { mode: 'image' });
        const image = CjTool.getImageContainer(target);
        image && rotateContainer.setChildIndex(image, rotateLength - 1);
        break;
      // case 'dai':
      //   focus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate);
      //   focus.visible = true;
      //   UiManager.ins.emit('l->r:change-image/frame', { mode: 'image' });
      //   const imageDai = CjTool.getImageContainer(target);
      //   imageDai && rotateContainer.setChildIndex(imageDai, rotateLength - 1);
      //   break;
      case 'move':
      case 'none':
        focus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.move);
        focus.visible = true;
        const imgArea = CjTool.getImageAreaContainer(target);
        const { scaleX: wrapperScale, originalBounds } = CjTool.getScaleContainer(target);
        const displayScale = { x: imgArea.scaleX * wrapperScale, y: imgArea.scaleY * wrapperScale }
        const scale = Math.min(displayScale.x, displayScale.y);
        const corners = CjTool.getFocusShapeIcons(target);
        for (const corner of corners) {
          corner.scaleX = (1 / displayScale.x) * scale;
          corner.scaleY = (1 / displayScale.y) * scale;
        }
        const lines = CjTool.getFocusLine(focus);
        const { width, height } = originalBounds;
        const transformBounds = { w: width * displayScale.x, h: height * displayScale.y }
        this.updateFocusLines(lines, transformBounds, displayScale, { dashed: true });
        break;
      default:
        break;
    }
    this.activeFocus = focus ?? null;
    const editablePhoto = CjTool.getDefaultContainer(target);
    const frameLength = this.stage.numChildren;
    editablePhoto && this.stage.setChildIndex(editablePhoto, frameLength - 1);
    const imaContainer = CjTool.getImageAreaContainer(target);
    const imaData = CjTool.getImageAreaContainer(target).getTransformedBounds();
    // 写真枠移動のときのツールチップ表示
    const pos = this.posManager.canvasToBrowser({
      // container の外側の座標だから container の座標を引いとく
      x: imaData.x + imaData.width / 2 - 86 + imaContainer.movePos.x,
      y: imaData.y + imaData.height + imaContainer.movePos.y + 10,
    });
    if (focusMode === 'move') {
      UiManager.ins.emit('l->r:show-tooltip', {
        type: 'frameMove',
        pos,
      });
    }
    // --- ツールメニューの表示 ---
    this.updateToolPos(focusMode, target);
    // this.stage.stage.getChildByName(CJ_CONTAINER_NAME.baseMask).visible = false;
  }

  // -- PNG画像のフォーカス --
  handlePngFocus(target: CjContainer) {
    if (target !== this.targetFrame || this.textEvent.targetFrame) {
      UiManager.ins.emit('l->r:dis-select');
      this.editableEvent.disFocused(this.targetFrame!);
      this.textEvent.targetFrame && this.editableEvent.disFocused(this.textEvent.targetFrame);
    }
    // --- すでに表示されているfocusの削除 ---
    UiManager.ins.emit('l->r:dis-select');
    const targetData = target.getTransformedBounds();
    // --- ツールメニューの表示 ---
    const pos: Pos = this.posManager.canvasToBrowser({
      x: targetData.x,
      y: targetData.y - 30,
    });
    CjTool.checkLoad(target).then((v) => {
      UiManager.ins.emit('l->r:select', {
        image: v,
        pos,
        isImgDisabled: true,
      });
    }).finally(() => {
      this.targetFrame = target;
      let focus = target.getChildByName(CJ_CONTAINER_NAME.focus.rotate) as CjContainer;
      focus.visible = true;
      this.layoutDataManager.dispatch('setFocusMode', 'png');
      UiManager.ins.emit('l->r:change-image/frame', { mode: 'image' });
      this.activeFocus = focus ?? null;
      const frameLength = this.stage.numChildren;
      target && this.stage.setChildIndex(target, frameLength - 1);
    });
  }

  // -- 移動開始 --
  handleMoveStart(target: CjContainer, e: any, isPng?: boolean) {
    if (this.transformed) return;
    const mouseX = Math.round(e.stageX - ImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - ImageEditManager.STAGE_CONTAINER_Y);
    this.dragPointX = mouseX;
    this.dragPointY = mouseY;
    UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
    // --- pngの移動 ---
    if (isPng) {
      // --- drag地点の保持 ---
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: target.x, y: target.y };
      return;
    }
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    // --- 写真入れ替えモード ---
    if (focusMode === 'rotate' || focusMode === 'dai' && this.activeFocus) {
      if (!CjTool.checkPhotoInFrame(target)) return;
      const photo = CjTool.getPhotoContainer(target);
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: Math.round(photo.x), y: Math.round(photo.y) };
    } else if (this.activeFocus) {
      // --- drag地点の保持 ---
      this.dragPointX -= target.x;
      this.dragPointY -= target.y;
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: target.x, y: target.y };
    }
    // 動かすときにはツールチップ非表示
    UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
  }

  // -- containerの移動 --
  handleMove(target: CjContainer, e: any, isPng?: boolean) {
    if (this.transformed) return;
    this.checkCounter++;
    this.isMove = true;
    this.dragTarget = target;
    const mouseX = Math.round(e.stageX - ImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - ImageEditManager.STAGE_CONTAINER_Y);
    if (isPng) {
      const { offsetX, offsetY } = this.smartGuideManager.calculateGuideSnap({ container: target, type: 'png' });
      const baseX = this.targetData.pos.x + (mouseX - this.dragPointX);
      const baseY = this.targetData.pos.y + (mouseY - this.dragPointY);
      target.x = this.smartGuideManager.applySnap(target.x, baseX, offsetX);
      target.y = this.smartGuideManager.applySnap(target.y, baseY, offsetY);
      return;
    }
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    // --- 写真入れ替えモード ---
    if (!this.activeFocus && focusMode !== 'dai') {
      if (Math.abs(mouseX - this.dragPointX) > 50
        || Math.abs(mouseY - this.dragPointY) > 50) {
        this.movingTarget = e.currentTarget;
        const checkPhoto = CjTool.checkPhotoInFrame(target);
        if (!this.movingTarget || !checkPhoto) return;
        if (this.isFastMove) {
          const photo = CjTool.getPhoto(this.movingTarget);
          this.previewImage = photo.clone();
          this.stage.addChild(this.previewImage);
          this.previewImage.set({
            x: mouseX,
            y: mouseY,
            scaleX: photo.scaleX / 2,
            scaleY: photo.scaleY / 2,
            alpha: 0.5,
            name: 'preview',
          });
          this.isFastMove = false;
        } else {
          if (this.previewImage) {
            this.previewImage.x = mouseX;
            this.previewImage.y = mouseY;
          }
        }
      } else {
        this.movingTarget = null;
      }
      // --- 繰り返し範囲を編集中のページに絞る ---
      const containers: CjContainer[] = this.layoutDataManager.selector('getImageAreas', e.currentTarget.pageId);
      // const containers = _containers.filter((v) => v.photoAreaId !== e.currentTarget.photoAreaId);
      for (const container of containers) {
        // --- ハイライトの抽出 ---
        const highlight = CjTool.getHighlight(container);
        // --- hitTestの対象指定 ---
        const point = container.globalToLocal(Math.round(e.stageX), Math.round(e.stageY));
        if (container.hitTest(point.x, point.y)) {
          // ---- 枠にハイライト ----
          if ((this.targetFrame === container && container.isChecked) || !highlight) return;
          if (container.photoAreaId !== e.currentTarget.photoAreaId) {
            highlight.visible = true;
          }
          // ---- 写真をドロップできる ----
          container.isChecked = true;
          // defaultContainer.mouseEnabled = false;
          this.targetFrame = container;
        } else {
          // ---- 枠外でハイライトの削除 ----
          if (!highlight) return;
          highlight.visible = false;
          // ---- 写真をドロップできない ----
          container.isChecked = false;
          // defaultContainer.mouseEnabled = true;
          this.targetFrame = null;
        }
        // NOTE: かなり重くなるかもしれないので要注意
        // --- 複数ハイライト時一番上に絞る ---
        const _targets = containers.filter((elm) => elm.isChecked);
        const targets = _targets.filter(v => !isNaN(Number(v.depth)));
        const max = Math.max(...targets.map(v => v.depth));
        targets.forEach(v => {
          if (v.depth !== max) {
            CjTool.getHighlight(v).visible = false;
          }
        });
      }
      return;
    }
    // --- 写真の移動 ---
    if ((focusMode === 'rotate' || focusMode === 'dai') && this.activeFocus) {
      if (!CjTool.checkPhotoInFrame(target)) return;
      const photo = CjTool.getPhotoContainer(target);
      const scaleContainer = CjTool.getScaleContainer(target);
      const rotateContainer = CjTool.getRotateContainer(target);
      const { offsetX, offsetY } = this.smartGuideManager.calculateGuideSnap({ container: photo, type: 'photo' });
      const offsetXInternal = offsetX !== undefined ? offsetX / scaleContainer.scaleX : undefined;
      const offsetYInternal = offsetY !== undefined ? offsetY / scaleContainer.scaleY : undefined;
      if (!rotateContainer.isRotate) {
        const baseX = this.targetData.pos.x + ((mouseX - this.dragPointX) / scaleContainer.scaleX);
        const baseY = this.targetData.pos.y + ((mouseY - this.dragPointY) / scaleContainer.scaleY);
        photo.x = this.smartGuideManager.applySnap(photo.x, baseX, offsetXInternal);
        photo.y = this.smartGuideManager.applySnap(photo.y, baseY, offsetYInternal);
      } else {
        const baseX = this.targetData.pos.x + ((mouseY - this.dragPointY) / scaleContainer.scaleY);
        const baseY = this.targetData.pos.y - ((mouseX - this.dragPointX) / scaleContainer.scaleX);
        const adjustedOffsetX = offsetXInternal !== undefined ? -offsetXInternal : offsetXInternal;
        photo.x = this.smartGuideManager.applySnap(photo.x, baseX, offsetYInternal);
        photo.y = this.smartGuideManager.applySnap(photo.y, baseY, adjustedOffsetX);
        // photo.movePos.x = mouseX - this.dragPointX;
        // photo.movePos.y = mouseY - this.dragPointY;
      }
      if (!(this.checkCounter % this.delayNum)) {
        const photoFrames: [] = this.layoutDataManager.selector('getEditors', photo.pageId);
        const isToast = FitChecker.checkImageOutBounds(photo, photoFrames, this.stage);
        this.imageEditManager.isFit = isToast;
        UiManager.ins.emit('l->r:show-toast', { isToast, target });
      }
    } else if (focusMode === 'move' && this.activeFocus) {
      const { offsetX, offsetY } = this.smartGuideManager.calculateGuideSnap({ container: target, type: 'photoFrame' });
      const baseX = mouseX - this.dragPointX;
      const baseY = mouseY - this.dragPointY;
      target.x = this.smartGuideManager.applySnap(target.x, baseX, offsetX);
      target.y = this.smartGuideManager.applySnap(target.y, baseY, offsetY);
    }
  }

  // -- containerの移動end --
  handleMoveEnd(container: CjContainer, e: any, isPng?: boolean) {
    this.smartGuideManager.clearGuideCache();
    if (!container || this.transformed || !this.isMove) {
      this.isExchange = false;
      this.isMove = false;
      this.dragTarget = null;
      this.checkCounter = 0;
      return;
    }
    this.isExchange = false;
    this.isMove = false;
    this.dragTarget = null;
    this.checkCounter = 0;
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    switch (container.name) {
      case CJ_CONTAINER_NAME.editor:
        const guid = CjTool.getGuidContainer(this.stage);
        if (!guid) break;
        if (!CjTool.hitTest(container, guid)) {

          const targetBef = this.targetData.pos;
          const leftBef = Math.round(targetBef.x);
          const topBef = Math.round(targetBef.y);
          const targetAf = container;
          const leftAf = Math.round(targetAf.x);
          const topAf = Math.round(targetAf.y);

          if (container) {
            container.x = leftBef;
            container.y = topBef;
            container.movePos.x -= leftAf - leftBef;
            container.movePos.y -= topAf - topBef;
          }
          return;
        }
        break;
      default:
        break;
    }
    // --- 写真入れ替えモード完了 ---
    if (this.previewImage) {
      this.stage.removeChild(this.previewImage);
      this.previewImage = null;
      this.isFastMove = true;
    }
    if (!this.activeFocus && focusMode !== 'dai') {
      const _containers: CjContainer[] = this.layoutDataManager.selector('getImageAreas', e.currentTarget.pageId);
      const containers = _containers.filter((v) => v.photoAreaId !== e.currentTarget.photoAreaId);
      const _targets = containers.filter((elm) => elm.isChecked);
      let targetFrame;
      if (_targets.length > 1) {
        const targets = _targets.filter(v => !isNaN(Number(v.depth)));
        const max = Math.max(...targets.map(v => v.depth));
        targetFrame = targets.find(v => v.depth === max);
        targets.forEach(v => {
          if (v.depth !== max) {
            CjTool.getHighlight(v).visible = false;
          }
        });
      } else {
        targetFrame = _targets[0];
      }
      _containers.forEach(v => {
        CjTool.getHighlight(v).visible = false;
        v.isChecked = false;
      });
      const imageBox: { image: EditableImage, target: CjContainer }[] = [];
      if (!targetFrame || !this.movingTarget) return;
      const targetContainer = CjTool.getScaleContainer(targetFrame);
      // ---- ドラッグ地点の画像 ----
      const isPhotoA = CjTool.checkPhotoInFrame(this.movingTarget);
      // ---- ドロップ地点の画像 ----
      const isPhotoB = CjTool.checkPhotoInFrame(targetContainer);
      if (this.movingTarget.photoAreaId === targetContainer.photoAreaId || !isPhotoA) return;
      // ---- ドローワーに追加済みの画像リスト ----
      const editableList = this.editableImageManager.list;
      // ---- ドラッグ地点 ----
      const photoContainerA = CjTool.getPhotoContainer(this.movingTarget);
      const photoA = editableList.find((v) => v.id === photoContainerA.editableImageId);
      imageBox.push({ image: photoA!, target: targetContainer });
      // ---- ドロップ地点 ----
      const photoContainerB = CjTool.getPhotoContainer(targetContainer);
      if (isPhotoB) {
        this.isExchange = true;
        const photoB = editableList.find((v) => v.id === photoContainerB.editableImageId);
        imageBox.push({ image: photoB!, target: this.movingTarget });
        const imageAreaA = CjTool.getImageAreaContainer(imageBox[0].target);
        const imageAreaB = CjTool.getImageAreaContainer(imageBox[1].target);
        if (imageAreaA.logoFlag !== imageAreaB.logoFlag) {
          UiManager.ins.emit('l->r:push-dialog', {
            title: '確認',
            message: [
              `写真枠とロゴ枠の画像の入れ替えはできません。`,
              `それぞれの枠に個別に画像をドラッグドロップして配置してください。`,
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => {
                  const highlightA = CjTool.getHighlight(imageAreaA);
                  const highlightB = CjTool.getHighlight(imageAreaB);
                  highlightA && (highlightA.visible = false);
                  highlightB && (highlightB.visible = false);
                },
              },
            ],
          });
          return;
        }
        this.editableEvent.action(
          'exchange',
          `${imageBox[0].image}と${imageBox[1].image}を交換`,
          () => {
            for (let i = 0; i < imageBox.length; i++) {
              this.imageController.createPhotoImage(imageBox[i].image, imageBox[i].target, {
                ...initPictureFlags,
                isExchange: true,
              });
            }
          },
          () => {
            this.imageController.createPhotoImage(imageBox[0].image, imageBox[1].target, {
              ...initPictureFlags,
              isExchange: true,
            });
            this.imageController.createPhotoImage(imageBox[1].image, imageBox[0].target, {
              ...initPictureFlags,
              isExchange: true,
            });
          },
        );
      } else {
        this.isExchange = true;
        const nowImageArea = CjTool.getImageAreaContainer(this.movingTarget);
        const nextImageArea = CjTool.getImageAreaContainer(targetContainer);
        if (nowImageArea.logoFlag !== nextImageArea.logoFlag) {
          UiManager.ins.emit('l->r:push-dialog', {
            title: '確認',
            message: [
              `写真枠とロゴ枠の画像の入れ替えはできません。`,
              `それぞれの枠に個別に画像をドラッグドロップして配置してください。`,
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => {
                  const highlightA = CjTool.getHighlight(nowImageArea);
                  const highlightB = CjTool.getHighlight(nextImageArea);
                  highlightA && (highlightA.visible = false);
                  highlightB && (highlightB.visible = false);
                },
              },
            ],
          });
          return;
        }
        this.editableEvent.action(
          'exchange',
          `${imageBox[0].image}を移動`,
          () => {
            const container = CjTool.getRotateContainer(this.movingTarget!);
            const imgContainer = CjTool.getImageContainer(this.movingTarget!);
            CjTool.getMaskContainer(container).alpha = 1;
            this.layoutDataManager.dispatch('removeImage', imgContainer);
            container.removeChild(imgContainer);
            this.imageController.createPhotoImage(photoA!, targetContainer, {
              ...initPictureFlags,
              isExchangeOne: true,
            }, imgContainer);
          },
          () => {
            const container = CjTool.getRotateContainer(targetContainer);
            const imgContainer = CjTool.getImageContainer(targetContainer);
            CjTool.getMaskContainer(container).alpha = 1;
            this.layoutDataManager.dispatch('removeImage', imgContainer);
            container.removeChild(imgContainer);
            this.imageController.createPhotoImage(photoA!, this.movingTarget!, {
              ...initPictureFlags,
              isExchangeOne: true,
            });
          },
        );

      }
      return;
    }
    if ((focusMode === 'rotate' || focusMode === 'dai') && !CjTool.checkPhotoInFrame(container)) return;
    // --- ターゲット指定 ---
    const target = (focusMode === 'rotate' || focusMode === 'dai')
      ? CjTool.getPhotoContainer(container)
      : container;
    // --- Redo ---
    const targetBef = this.targetData.pos;
    const leftBef = targetBef.x;
    const topBef = targetBef.y;
    // --- Undo ---
    const targetAf = target;
    const leftAf = targetAf.x;
    const topAf = targetAf.y;
    // --- movePos ---
    const movePos = focusMode === 'move'
      ? CjTool.getImageAreaContainer(target).movePos
      : target.movePos;
    const prevBase = (focusMode === 'rotate' || focusMode === 'dai')
      ? CjTool.getDefaultContainer(target)
      : target;
    // --- fire ---
    this.editableEvent.action(
      'move',
      `left: ${leftBef} → ${leftAf}, top: ${topBef} → ${topAf} に移動`,
      () => {
        let prevTarget;
        if (target) {
          if (!this.isFocus) {
            const isPng = focusMode === 'png';
            if (isPng || focusMode !== 'move') {
              this.imageEditableTool.imageMode(prevBase, isPng);
            }
          }
          prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
            ? CjTool.getPhotoContainer(prevBase)
            : prevBase;
          prevTarget.x = leftAf;
          prevTarget.y = topAf;
          movePos.x += leftAf - leftBef;
          movePos.y += topAf - topBef;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            if (!(this.checkCounter % this.delayNum)) {
              const photoFrames: [] = this.layoutDataManager.selector('getEditors', prevTarget.pageId);
              const isToast = FitChecker.checkImageOutBounds(prevTarget, photoFrames, this.stage);
              this.imageEditManager.isFit = isToast;
              UiManager.ins.emit('l->r:show-toast', { isToast, target });
            }
          }
        }
      },
      () => {
        let prevTarget;
        if (!this.isFocus) {
          const isPng = focusMode === 'png';
          if (isPng || focusMode !== 'move') {
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
        }
        prevTarget = (focusMode === 'rotate' || focusMode === 'dai')
          ? CjTool.getPhotoContainer(prevBase)
          : prevBase;
        if (target) {
          prevTarget.x = leftBef;
          prevTarget.y = topBef;
          movePos.x -= leftAf - leftBef;
          movePos.y -= topAf - topBef;
          if (focusMode === 'rotate' || focusMode === 'dai') {
            if (!(this.checkCounter % this.delayNum)) {
              const photoFrames: [] = this.layoutDataManager.selector('getEditors', prevTarget.pageId);
              const isToast = FitChecker.checkImageOutBounds(prevTarget, photoFrames, this.stage);
              this.imageEditManager.isFit = isToast;
              UiManager.ins.emit('l->r:show-toast', { isToast, target });
            }
          }
        }
      },
    );
    const containerData = container.getTransformedBounds();
    const pos = this.posManager.canvasToBrowser({
      // container の外側の座標だから container の座標を引いとく
      x: containerData.x + containerData.width / 2 - 86 + container.movePos.x,
      y: containerData.y + containerData.height + container.movePos.y + 10,
    });
    if (focusMode === 'move') {
      UiManager.ins.emit('l->r:show-tooltip', {
        type: 'frameMove',
        pos,
      });
    } else {
      this.updateToolPos(focusMode, target);
    }
  }

  // -- containerの拡縮start --
  handleTransformStart(target: CjContainer, e: any) {
    this.transformed = true;
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    // --- drag地点の保持 ---
    const mouseX = Math.round(e.stageX - ImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - ImageEditManager.STAGE_CONTAINER_Y);
    this.dragPointX = Math.round(mouseX);
    this.dragPointY = Math.round(mouseY);

    // --- コンテナ用意 ---
    let container;
    let area;
    let pointA;
    let pointB;
    let pointC;
    // ---クリック地点の角度算出 A:起点(枠の半分, 0) B:中心点（枠の半分, 枠の半分） C:クリック地点 ---
    if (focusMode === 'rotate' || focusMode === 'dai') {
      container = CjTool.getPhotoContainer(target);
      area = CjTool.getImageAreaContainer(target);
      const scaleContainer = CjTool.getScaleContainer(target);
      const areaData = area.getBounds();
      pointA = { x: areaData.x + areaData.width / 2 + (container.movePos.x * scaleContainer.scaleX) + area.movePos.x, y: (container.movePos.y * scaleContainer.scaleX) + area.movePos.y };
      pointB = {
        x: areaData.x + areaData.width / 2 + (container.movePos.x * scaleContainer.scaleX) + area.movePos.x,
        y: areaData.y + areaData.height / 2 + (container.movePos.y * scaleContainer.scaleX) + area.movePos.y,
      };
      pointC = { x: mouseX, y: mouseY };

      if (!CjTool.checkPhotoInFrame(target)) return;
      const photoContainer = CjTool.getPhotoContainer(target);
      // --- Redo用移動前座標の保持 ---
      this.targetData.rotation = photoContainer.rotation;
      this.targetData.pos = { x: photoContainer.x, y: photoContainer.y };
      this.targetData.scale = { x: photoContainer.scaleX, y: photoContainer.scaleY };
      this.targetData.reg = { x: photoContainer.regX, y: photoContainer.regY };
    } else if (focusMode === 'png') {
      container = target;
      const containerData = container.getBounds();
      pointA = { x: target.regX - containerData.width / 2 + target.movePos.x, y: 0 };
      pointB = {
        x: target.regX - containerData.width / 2 + target.movePos.x,
        y: target.regY - containerData.height / 2 + target.movePos.y,
      };
      pointC = { x: mouseX, y: mouseY };
      // --- Redo用移動前座標の保持 ---
      this.targetData.rotation = target.rotation;
      this.targetData.pos = { x: target.x, y: target.y };
      this.targetData.scale = { x: target.scaleX, y: target.scaleY };
      this.targetData.reg = { x: target.regX, y: target.regY };
    } else {
      const { x: editorX, y: editorY } = CjTool.getDefaultContainer(target);
      container = CjTool.getImageAreaContainer(target);
      const { scaleY: wrapperScale, originalBounds, x, y, } = CjTool.getScaleContainer(target);
      const centerX = x + container.movePos.x;
      const centerY = y + container.movePos.y;
      const displayScaleY = wrapperScale * container.scaleY;
      pointA = { x: centerX, y: centerY - originalBounds.height * displayScaleY / 2 };
      pointB = { x: centerX, y: centerY };
      pointC = { x: mouseX, y: mouseY };
      // --- Redo用移動前座標の保持 ---
      this.targetData.pos = { x: editorX, y: editorY };
      this.targetData.scale = { x: container.scaleX, y: container.scaleY };
      this.targetData.reg = { x: container.regX, y: container.regY };
      this.targetData.wrapperScale = wrapperScale;
    }
    // --- 角度からクリックされたハンドル位置を特定 ---
    if (e.target.name === CJ_FOCUS_NAME.side) {
      const rotParent = CjTool.getRotateContainer(target);
      const rotation = rotParent.rotation % 360;
      const shift = Math.round(rotation / 90) % 4;
      const pos = e.target.position;
      const rotatedPos = SIDE_POSITIONS[(SIDE_POSITIONS.indexOf(pos) + shift + 4) % 4];
      this.iconPosition = rotatedPos;
    } else {
      const radianA = Math.atan2(pointA.x - pointB.x, pointA.y - pointB.y);
      const radianB = Math.atan2(pointC.x - pointB.x, pointC.y - pointB.y);
      const angle = (radianA - radianB) / Math.PI * 180;
      if (angle >= 0 && angle < 90) {
        this.iconPosition = 'rt';
      } else if (angle >= 90 && angle < 180) {
        this.iconPosition = 'rb';
      } else if (angle >= 180 && angle < 270) {
        this.iconPosition = 'lb';
      } else if (angle >= 270 && angle < 360) {
        this.iconPosition = 'lt';
      }
    }
    // --- png画像時の原点ずれによるコーナ情報のずれを抑制 ---
    if (focusMode === 'png') {
      const targetCorner = e.target.position
      const targetAngle = target.rotation < 0 ? target.rotation + 360 : target.rotation % 360
      switch (targetCorner) {
        case 'rt':
          if (targetAngle >= 315 || (targetAngle >= 0 && targetAngle < 45)) {
            this.iconPosition = 'rt';
          } else if (targetAngle >= 45 && targetAngle < 135) {
            this.iconPosition = 'rb';
          } else if (targetAngle >= 135 && targetAngle < 225) {
            this.iconPosition = 'lb';
          } else if (targetAngle >= 225 && targetAngle < 315) {
            this.iconPosition = 'lt';
          }
          break;
        case 'lb':
          if (targetAngle >= 315 || (targetAngle >= 0 && targetAngle < 45)) {
            this.iconPosition = 'lb';
          } else if (targetAngle >= 45 && targetAngle < 135) {
            this.iconPosition = 'lt';
          } else if (targetAngle >= 135 && targetAngle < 225) {
            this.iconPosition = 'rt';
          } else if (targetAngle >= 225 && targetAngle < 315) {
            this.iconPosition = 'rb';
          }
          break;
        default:
          break;
      }
    }
  }

  // -- containerの拡縮処理 --
  handleScaleMove(target: CjContainer, e: any) {
    this.checkCounter++;
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    const isPng = focusMode === 'png';
    const isScale = focusMode === 'scale';
    const isRotate = focusMode === 'rotate';
    const isRotOrDai = isRotate || focusMode === 'dai';
    const isNonPng = !isPng;
    const imgArea = isNonPng ? CjTool.getImageAreaContainer(target) : target;
    const scaleContainer = isNonPng ? CjTool.getScaleContainer(imgArea) : target;
    const rotContainer = isNonPng ? CjTool.getRotateContainer(target) : undefined;
    const isRotated = !!rotContainer?.isRotate;
    const backContainer = isNonPng && CjTool.hasBack(target) ? CjTool.getBackContainer(target) : undefined;
    const isFreeSize = isSidePosition(this.iconPosition);
    let container;
    if (isRotOrDai) {
      container = CjTool.getPhotoContainer(target);
    } else if (isPng) {
      container = target;
    } else if (isFreeSize) {
      container = CjTool.getImageAreaContainer(target);
    } else {
      container = CjTool.getScaleContainer(target);
    }
    const mouseX = Math.round(e.stageX - ImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - ImageEditManager.STAGE_CONTAINER_Y);
    const difX = (mouseX - this.dragPointX);
    const difY = (mouseY - this.dragPointY);
    const width = isScale ? scaleContainer.originalBounds.width : container.originalBounds.width;
    const height = isScale ? scaleContainer.originalBounds.height : container.originalBounds.height;
    let sizeX = width * (isRotOrDai ? scaleContainer.scaleX : 1);
    let sizeY = height * (isRotOrDai ? scaleContainer.scaleY : 1);
    let targetScaleX = this.targetData.scale.x * (isScale ? this.targetData.wrapperScale : 1);
    let targetScaleY = this.targetData.scale.y * (isScale ? this.targetData.wrapperScale : 1);
    if (isScale && isRotated) {
      [sizeX, sizeY] = [sizeY, sizeX];
      [targetScaleX, targetScaleY] = [targetScaleY, targetScaleX];
    }
    let scaleX;
    let scaleY;
    switch (this.iconPosition) {
      case 'lt':
        scaleX = (((sizeX * targetScaleX) + (difX * -2))) / sizeX;
        scaleY = (((sizeY * targetScaleY) + (difY * -2))) / sizeY;
        break;
      case 'rt':
        scaleX = (((sizeX * targetScaleX) + (difX * 2))) / sizeX;
        scaleY = (((sizeY * targetScaleY) + (difY * -2))) / sizeY;
        break;
      case 'rb':
        scaleX = (((sizeX * targetScaleX) + (difX * 2))) / sizeX;
        scaleY = (((sizeY * targetScaleY) + (difY * 2))) / sizeY;
        break;
      case 'lb':
        scaleX = (((sizeX * targetScaleX) + (difX * -2))) / sizeX;
        scaleY = (((sizeY * targetScaleY) + (difY * 2))) / sizeY;
        break;
      case 't':
        scaleX = targetScaleX;
        scaleY = (((sizeY * targetScaleY) - difY)) / sizeY;
        break;
      case 'b':
        scaleX = targetScaleX;
        scaleY = (((sizeY * targetScaleY) + difY)) / sizeY;
        break;
      case 'l':
        scaleX = (((sizeX * targetScaleX) - difX)) / sizeX;
        scaleY = targetScaleY;
        break;
      case 'r':
        scaleX = (((sizeX * targetScaleX) + difX)) / sizeX;
        scaleY = targetScaleY;
        break;
      default:
        scaleX = targetScaleX;
        scaleY = targetScaleY;
        break;
    }
    // --- スケール操作処理 ---
    if (isScale && isRotated) [scaleX, scaleY] = [scaleY, scaleX];
    // 20%~400%の間でscaling
    // PNG(freeGraphic)はeditableが最大1000pxのサムネのため初期表示が実寸より小さい。
    // pngResizeScale(=realW/T)をclampに掛け、到達サイズを「元画像の実寸」基準の0.2〜4倍にする。
    const pngFactor = focusMode === 'png' ? (target.pngResizeScale ?? 1) : 1;
    const scaleMin = (imgArea.logoFlag && !target.logoFlag) ? (imgArea.initResizeScale ?? 1) * 0.2 : 0.2 * pngFactor;
    const scaleMax = (imgArea.logoFlag && !target.logoFlag) ? (imgArea.initResizeScale ?? 1) * 4 : 4 * pngFactor;
    const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));
    const floorTo = (value: number) => Math.floor(value * 1000) / 1000;
    // コンテナ情報更新
    if (isFreeSize) {
      // 非等倍スケール
      scaleX = floorTo(clamp(scaleX, scaleMin, scaleMax));
      scaleY = floorTo(clamp(scaleY, scaleMin, scaleMax));
      const imgScaleX = floorTo(scaleX / this.targetData.wrapperScale);
      const imgScaleY = floorTo(scaleY / this.targetData.wrapperScale);
      container.set({ scaleX: imgScaleX, scaleY: imgScaleY });
      // 背景も一緒にスケーリング
      if (backContainer) backContainer.set({ scaleX: imgScaleX, scaleY: imgScaleY });
      // --- 反対側の辺を動かさないための位置補正 ---
      const round5 = (num: number) => Math.round(num * 1e5) / 1e5;
      if (isScale && isRotated) [scaleX, scaleY] = [scaleY, scaleX];
      const deltaW = round5(sizeX * scaleX) - round5(sizeX * targetScaleX);
      const deltaH = round5(sizeY * scaleY) - round5(sizeY * targetScaleY);
      if (isScale && isRotated) [scaleX, scaleY] = [scaleY, scaleX];
      const regDiff = {
        x: isScale && isRotated ? -container.differPos.y : container.differPos.x,
        y: isScale && isRotated ? container.differPos.x : container.differPos.y,
      }
      const ratioXBase = round5(regDiff.x / sizeX);
      const ratioX = this.iconPosition === 'l' ? -ratioXBase : ratioXBase;
      const ratioYBase = round5(regDiff.y / sizeY);
      const ratioY = this.iconPosition === 't' ? -ratioYBase : ratioYBase;
      const dx = (this.iconPosition === 'l' ? -1 : this.iconPosition === 'r' ? 1 : 0) * (deltaW * (0.5 + ratioX));
      const dy = (this.iconPosition === 't' ? -1 : this.iconPosition === 'b' ? 1 : 0) * (deltaH * (0.5 + ratioY));
      CjTool.getDefaultContainer(target).set({ x: this.targetData.pos.x + dx, y: this.targetData.pos.y + dy });
    } else {
      const ratio = this.targetData.scale.x / this.targetData.scale.y;
      const useX = scaleX >= scaleY;
      let base = useX ? scaleX : scaleY;
      if (useX) {
        const baseMin = Math.max(scaleMin, scaleMin * ratio);
        const baseMax = Math.min(scaleMax, scaleMax * ratio);
        base = clamp(base, baseMin, baseMax);
        scaleX = base;
        scaleY = base / ratio;
      } else {
        const baseMin = Math.max(scaleMin, scaleMin / ratio);
        const baseMax = Math.min(scaleMax, scaleMax / ratio);
        base = clamp(base, baseMin, baseMax);
        scaleY = base;
        scaleX = base * ratio;
      }
      scaleX = floorTo(scaleX);
      scaleY = floorTo(scaleY);
      const wrapperScale = floorTo(scaleX / (isScale ? this.targetData.scale.x : 1));
      container.set({ scaleX: wrapperScale, scaleY: wrapperScale });
    }
    // フォーカスの枠線もスケールに合わせて再描画
    const focusName = CJ_CONTAINER_NAME.focus[isScale ? 'scale' : 'rotate'];
    const targetFocus = isNonPng ? CjTool.getFocusContainer(target, focusName) : undefined;
    const lines = targetFocus ? CjTool.getFocusLine(targetFocus) : CjTool.getFocusLines(target, isPng);
    if (isScale && isRotated) [sizeX, sizeY] = [sizeY, sizeX];
    const originalW = isRotate ? container.originalBounds.width : sizeX;
    const originalH = isRotate ? container.originalBounds.height : sizeY;
    const originalScaleX = scaleX * (isRotate ? scaleContainer.scaleX : 1);
    const originalScaleY = scaleY * (isRotate ? scaleContainer.scaleY : 1);
    this.updateFocusLines(
      lines,
      { w: originalW * originalScaleX, h: originalH * originalScaleY },
      { x: originalScaleX, y: originalScaleY },
    );
    // フォーカスの操作ハンドルもスケールに合わせて整形
    const handleIcons = targetFocus ? CjTool.getFocusHandleIcon(targetFocus) : CjTool.getFocusHandleIcons(container, true);
    if (isScale && isRotated) [scaleX, scaleY] = [scaleY, scaleX];
    for (const icon of handleIcons) {
      let iconScaleX = scaleX;
      let iconScaleY = scaleY;
      if (icon.parent.parent.name === 'photo-container') {
        iconScaleX *= scaleContainer.scaleX;
        iconScaleY *= scaleContainer.scaleY;
      }
      if (isNonPng && isScale) {
        const rot = ((icon.rotation ?? 0) + (isRotated ? 90 : 0)) % 360;
        if (rot === 90 || rot === 270) [iconScaleX, iconScaleY] = [iconScaleY, iconScaleX];
      }
      icon.scaleX = 1 / iconScaleX;
      icon.scaleY = 1 / iconScaleY;
    }
    // マスク更新
    if (isScale && CjTool.checkPhotoInFrame(target)) ImageController.updateImageCache(imgArea);
    // 余白判定
    if (isRotOrDai) {
      if (!CjTool.checkPhotoInFrame(target)) return;
      const photo = CjTool.getPhotoContainer(target);
      if (!(this.checkCounter % this.delayNum)) {
        const photoFrames: [] = this.layoutDataManager.selector('getEditors', photo.pageId);
        const isToast = FitChecker.checkImageOutBounds(photo, photoFrames, this.stage);
        this.imageEditManager.isFit = isToast;
        UiManager.ins.emit('l->r:show-toast', { isToast, target });
      }
    }
  }

  handleRotateMove(target: CjContainer, e: any, moveTo: IconPosition) {
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    this.checkCounter++;
    const container = focusMode === 'rotate'
      ? CjTool.getPhotoContainer(target)
      : target;
    const containerData = container.getBounds();
    const mouseX = Math.round(e.stageX - ImageEditManager.STAGE_CONTAINER_X);
    const mouseY = Math.round(e.stageY - ImageEditManager.STAGE_CONTAINER_Y);
    // --- A:ドラッグ起点 B：画像の中心 C：現在のマウス地点 ---
    let pointA;
    let pointB;
    const pointC = { x: mouseX, y: mouseY };

    if (focusMode === 'rotate' || focusMode === 'dai') {
      const area = CjTool.getImageAreaContainer(target);
      const areaData = area.getBounds();
      pointA = { x: this.dragPointX, y: this.dragPointY };
      pointB = {
        x: areaData.x + areaData.width / 2 + container.movePos.x + area.movePos.x,
        y: areaData.y + areaData.height / 2 + container.movePos.y + area.movePos.y,
      };
      if (!(this.checkCounter % this.delayNum)) {
        const photoFrames: [] = this.layoutDataManager.selector('getEditors', container.pageId);
        const isToast = FitChecker.checkImageOutBounds(container, photoFrames, this.stage);
        this.imageEditManager.isFit = isToast;
        UiManager.ins.emit('l->r:show-toast', { isToast, target });
      }
    } else {
      pointA = { x: this.dragPointX, y: this.dragPointY };
      pointB = focusMode === 'png'
        ? {
          x: containerData.x + container.movePos.x,
          y: containerData.y + container.movePos.y,
        }
        : {
          x: containerData.x + containerData.width / 2 + container.movePos.x,
          y: containerData.y + containerData.height / 2 + container.movePos.y,
        };
    }
    const radianA = Math.atan2(pointA.x - pointB.x, pointA.y - pointB.y);
    const radianB = Math.atan2(pointC.x - pointB.x, pointC.y - pointB.y);
    const angle = (radianA - radianB) / Math.PI * 180;

    const nextRotate = this.targetData.rotation + angle;
    container.rotation = 0 > nextRotate ? 360 + nextRotate : nextRotate;
  }


  // -- containerの拡縮end --
  handleTransformEnd(target: CjContainer, e: any) {
    this.checkCounter = 0;

    const ratio = (_handleIcon: CjFocusHandleIcon) => _handleIcon.parent.parent.name === 'photo-container' ? CjTool.getImageAreaContainer(target).scaleX : 1;
    const focusMode = this.layoutDataManager.selector('getFocusMode');
    const isPng = focusMode === 'png';
    const focusRotate = focusMode === 'rotate';
    const isRotOrDai = focusRotate || focusMode === 'dai';
    if (isPng || isRotOrDai) {
      const photoContainer = isRotOrDai ? CjTool.getPhotoContainer(target) : target;
      const { width, height } = photoContainer.originalBounds;
      const wrapperScale = isRotOrDai ? CjTool.getScaleContainer(target).scaleX : 1;
      const targetFocus = isRotOrDai ? CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.rotate) : undefined;
      const lines = targetFocus ? CjTool.getFocusLine(targetFocus) : CjTool.getFocusLines(target, true);
      const handleIcons = targetFocus ? CjTool.getFocusHandleIcon(targetFocus) : CjTool.getFocusHandleIcons(target, true);
      const round = (value: number) => Math.floor(value * 100) / 100;
      // --- Redo ---
      const rotateBef = round(this.targetData.rotation);
      const scaleXBef = focusRotate ? this.targetData.scale.x : round(this.targetData.scale.x);
      const scaleYBef = focusRotate ? this.targetData.scale.y : round(this.targetData.scale.y);
      // --- Undo ---
      const rotateAf = round(photoContainer.rotation);
      const scaleXAf = focusRotate ? photoContainer.scaleX : round(photoContainer.scaleX);
      const scaleYAf = focusRotate ? photoContainer.scaleY : round(photoContainer.scaleY);
      const prevBase = isRotOrDai ? CjTool.getDefaultContainer(target) : target;
      // --- fire ---
      this.editableEvent.action(
        'transform',
        `${rotateBef}から${rotateAf}度まで回転。${scaleXBef}から${scaleXAf}倍まで拡縮。`,
        () => {
          let prevTarget;
          if (!this.isFocus) {
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
          prevTarget = isRotOrDai ? CjTool.getPhotoContainer(prevBase) : prevBase;
          prevTarget.rotation = rotateAf;
          prevTarget.scaleX = scaleXAf;
          prevTarget.scaleY = scaleYAf;
          prevTarget.addDifferPos.x = prevTarget.originalBounds.width * scaleXAf - prevTarget.virtual.width;
          prevTarget.addDifferPos.y = prevTarget.originalBounds.height * scaleYAf - prevTarget.virtual.height;
          if (!(this.checkCounter % this.delayNum)) {
            const photoFrames: [] = this.layoutDataManager.selector('getEditors', prevTarget.pageId);
            const isToast = FitChecker.checkImageOutBounds(prevTarget, photoFrames, this.stage);
            this.imageEditManager.isFit = isToast;
            UiManager.ins.emit('l->r:show-toast', { isToast, target });
          }
          this.layoutDataManager.dispatch('setScale', prevTarget);
          const displayScale = { x: scaleXAf * wrapperScale, y: scaleYAf * wrapperScale };
          handleIcons.forEach(icon => this.adjustHandleIconScale(target, icon, displayScale.x, displayScale.y, true));
          this.updateFocusLines(lines, { w: width * displayScale.x, h: height * displayScale.y }, displayScale);
        },
        () => {
          if (!this.isFocus) {
            this.imageEditableTool.imageMode(prevBase, isPng);
          }
          let prevTarget;
          prevTarget = isRotOrDai ? CjTool.getPhotoContainer(prevBase) : prevBase;
          prevTarget.rotation = rotateBef;
          prevTarget.scaleX = scaleXBef;
          prevTarget.scaleY = scaleYBef;
          prevTarget.addDifferPos.x = prevTarget.originalBounds.width / scaleXAf - prevTarget.virtual.width;
          prevTarget.addDifferPos.y = prevTarget.originalBounds.height / scaleYAf - prevTarget.virtual.height;
          if (!(this.checkCounter % this.delayNum)) {
            const photoFrames: [] = this.layoutDataManager.selector('getEditors', prevTarget.pageId);
            const isToast = FitChecker.checkImageOutBounds(prevTarget, photoFrames, this.stage);
            this.imageEditManager.isFit = isToast;
            UiManager.ins.emit('l->r:show-toast', { isToast, target });
          }
          this.layoutDataManager.dispatch('setScale', prevTarget);
          const displayScale = { x: scaleXBef * wrapperScale, y: scaleYBef * wrapperScale };
          handleIcons.forEach(icon => this.adjustHandleIconScale(target, icon, displayScale.x, displayScale.y, true));
          this.updateFocusLines(lines, { w: width * displayScale.x, h: height * displayScale.y }, displayScale);
        },
      );
    } else {
      const imgArea = CjTool.getImageAreaContainer(target);
      const scaleContainer = CjTool.getScaleContainer(target);
      const backContainer = CjTool.hasBack(target) ? CjTool.getBackContainer(target) : undefined;
      const editorContainer = CjTool.getDefaultContainer(target);
      /** 画像の余白フィット状態を更新し、必要に応じてトーストを表示する */
      const updatePhotoFitStatus = (target: CjContainer) => {
        const photo = CjTool.getPhotoContainer(target);
        const photoFrames: [] = this.layoutDataManager.selector('getEditors', photo.pageId);
        const isToast = FitChecker.checkImageOutBounds(photo, photoFrames, this.stage);
        this.imageEditManager.isFit = isToast;
        UiManager.ins.emit('l->r:show-toast', { isToast, target });
      };
      /**
       * フィット判定 → マスクキャッシュ再構築を順序付きで実行する。
       * FitChecker が checker.alpha を変更するため、updateImageCache より先に呼ぶ
       * (キャッシュ構築後に alpha 変更すると次回再キャッシュまで反映されないため)
       */
      const refreshFitAndMask = () => {
        if (!CjTool.checkPhotoInFrame(target)) return;
        updatePhotoFitStatus(target);
        ImageController.updateImageCache(imgArea);
      };
      const targetFocus = CjTool.getFocusContainer(target, CJ_CONTAINER_NAME.focus.scale);
      const handleIcons = CjTool.getFocusHandleIcon(targetFocus);
      // --- Redo ---
      const scaleXBef = this.targetData.scale.x;
      const scaleYBef = this.targetData.scale.y;
      const wrapperScaleBef = this.targetData.wrapperScale;
      const posXBef = this.targetData.pos.x;
      const posYBef = this.targetData.pos.y;
      // --- Undo ---
      const scaleXAf = imgArea.scaleX;
      const scaleYAf = imgArea.scaleY;
      const wrapperScaleAf = scaleContainer.scaleX;
      const posXAf = editorContainer.x;
      const posYAf = editorContainer.y;
      // --- fire ---
      this.editableEvent.action(
        'scale',
        `${scaleXBef}から${scaleXAf}倍まで拡縮。`,
        () => {
          scaleContainer.set({ scaleX: wrapperScaleAf, scaleY: wrapperScaleAf });
          imgArea.set({ scaleX: scaleXAf, scaleY: scaleYAf });
          if (backContainer) backContainer.set({ scaleX: scaleXAf, scaleY: scaleYAf });
          // フリーサイズの座標調整分
          editorContainer.set({ x: posXAf, y: posYAf });
          imgArea.movePos.x += posXAf - posXBef;
          imgArea.movePos.y += posYAf - posYBef;
          refreshFitAndMask();
          const displayScale = { x: scaleXAf * wrapperScaleAf, y: scaleYAf * wrapperScaleAf }
          handleIcons.forEach(icon => this.adjustHandleIconScale(target, icon, displayScale.x, displayScale.y));
          this.updateFocusLine(target, targetFocus, displayScale);
        },
        () => {
          scaleContainer.set({ scaleX: wrapperScaleBef, scaleY: wrapperScaleBef });
          imgArea.set({ scaleX: scaleXBef, scaleY: scaleYBef });
          if (backContainer) backContainer.set({ scaleX: scaleXBef, scaleY: scaleYBef });
          // フリーサイズの座標調整分
          editorContainer.set({ x: posXBef, y: posYBef });
          imgArea.movePos.x -= posXAf - posXBef;
          imgArea.movePos.y -= posYAf - posYBef;
          refreshFitAndMask();
          const displayScale = { x: scaleXBef * wrapperScaleBef, y: scaleYBef * wrapperScaleBef }
          handleIcons.forEach(icon => this.adjustHandleIconScale(target, icon, displayScale.x, displayScale.y));
          this.updateFocusLine(target, targetFocus, displayScale);
        },
      );
      // this.imageEditableTool.frameMode(target);
    }
    this.updateToolPos(focusMode, target);
    this.transformed = false;
  }

  // マウスオーバーのイベント（ツールチップ表示）
  mouseOverEvent(e: MouseEvent, image: CjContainer) {
    let defaultPos = { x: this.stage.stage.mouseX, y: this.stage.stage.mouseY };
    this.timerId = setInterval(() => {
      if (defaultPos.x === this.stage.stage.mouseX
        && defaultPos.y === this.stage.stage.mouseY) {
        if (this.showToolTip) return;
        this.showToolTip = true;
        const photo = CjTool.checkPhotoInFrame(e.currentTarget as CjContainer);
        const pos = this.posManager.canvasToBrowser({
          // container の外側の座標だから container の座標を引いとく
          x: this.stage.stage.mouseX - ImageEditManager.STAGE_CONTAINER_X + 10,
          y: this.stage.stage.mouseY - ImageEditManager.STAGE_CONTAINER_Y + 10,
        });
        if (photo && !this.activeFocus && this.isSelect) {
          UiManager.ins.emit('l->r:show-tooltip', {
            type: 'imageHover',
            pos,
          });
        }
      } else {
        this.showToolTip = false;
        defaultPos = { x: this.stage.stage.mouseX, y: this.stage.stage.mouseY };
        const photo = CjTool.checkPhotoInFrame(image);
        if (photo && !this.activeFocus) {
          UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
        }
      }
    }, 300);
  }

  // マウスアウトのイベント（ツールチップ表示）
  mouseOutEvent(e: MouseEvent, image: CjContainer) {
    this.timerId && clearInterval(this.timerId);
    this.showToolTip = false;
    const photo = CjTool.checkPhotoInFrame(image);
    if (photo && !this.activeFocus) {
      UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
    }
  }

  // イメージのハンドラ設定
  setImageEvent(image: CjContainer, type: 'frame' | 'image' | 'dai' | 'none', focus?: FocusModeType) {
    if (type === 'dai') {
      const focusMode = this.layoutDataManager.selector('getFocusMode');
      image.on('click', (e: any) => {
        e.stopPropagation();
        this.trimmingManager.moveEnd();
        if (!this.isSelect) return;
        if (this.textEvent.isFocus) {
          this.textEvent.targetFrame && this.editableEvent.disFocused(this.textEvent.targetFrame);
          return;
        }
        if (this.clicked) {
          this.clicked = false;
          if (this.textEvent.isActive) return;
          const prevPhotoImage = CjTool.checkPhotoInFrame(image);
          if (prevPhotoImage) {
            if ((focusMode === 'scale' || focusMode === 'DAI')) {
              this.imageEditableTool.imageMode(image, false, true);
              UiManager.ins.emit('l->r:change-image/frame', { mode: 'image', isAdditional: true });
            }
          }
          return;
        }
        // --- シングルクリックの場合 ---
        this.clicked = true;
        // --- ダブルクリック受付時間 ---
        setTimeout(() => {
          // ---- ダブルクリックだとfalse ----
          if (this.clicked && focusMode !== 'rotate') {
            if (this.textEvent.isActive) return;
            UiManager.ins.emit('l->r:change-middle-frame', { id: Number(image.photoAreaId) });
          }
          this.clicked = false;
        }, 250);

      });
    }
    if (type === 'image') {
      CjTool.checkLoad(image).then((v) => {
        this.createFocus(v, focus ? focus : 'rotate')
          .then((container) => {
            container.visible = false;
            image.addChild(container);
          });
      });
      if (focus === 'png') {
        image.on('click', (e: any) => {
          e.stopPropagation();
          if (!this.isSelect || this.textEvent.isInsert) return;
          const handleIcons = CjTool.getFocusHandleIcons(image, true);
          for (const icon of handleIcons) {
            const scale = 1 / image.scaleX;
            icon.scaleX = scale;
            icon.scaleY = scale;
          }
          const lines = CjTool.getFocusLines(image, true);
          const { scaleX, scaleY, originalBounds } = image;
          this.updateFocusLines(
            lines,
            { w: originalBounds.width * scaleX, h: originalBounds.height * scaleY },
            { x: scaleX, y: scaleY },
          );
          this.imageEditableTool.imageMode(image, true);
          UiManager.ins.emit('l->r:change-image/frame', { mode: 'image' });
        });
      }
    } else {
      const imageArea = CjTool.getImageAreaContainer(image);
      if (type === 'frame') {
        CjTool.checkLoad(imageArea).then((v) => {
          this.createFocus(v, 'scale', true)
            .then((container) => {
              container.visible = false;
              imageArea.addChild(container);
            });
          this.createFocus(v, 'move')
            .then((container) => {
              container.visible = false;
              imageArea.addChild(container);
            });
        });
        imageArea.removeAllEventListeners();
        // -- 枠の選択（フォーカスする） --
        imageArea.on('click', (e: any) => {
          e.stopPropagation();
          if (this.textEvent.isInsert) return;
          const _imageArea = CjTool.getImageAreaContainer(image);
          const { scaleX: wrapperScale } = CjTool.getScaleContainer(_imageArea);
          const targetFocus = CjTool.getFocusContainer(_imageArea, CJ_CONTAINER_NAME.focus.scale);
          const handleIcons = CjTool.getFocusHandleIcon(targetFocus);
          const displayScale = { x: _imageArea.scaleX * wrapperScale, y: _imageArea.scaleY * wrapperScale }
          handleIcons.forEach(icon => this.adjustHandleIconScale(_imageArea, icon, displayScale.x, displayScale.y));
          this.updateFocusLine(_imageArea, targetFocus, { x: displayScale.x, y: displayScale.y });
          const focusMode = this.layoutDataManager.selector('getFocusMode');
          if (!this.isSelect) return;
          // if (focusMode !== 'scale' || !this.isSelect) return;
          // --- ダブルクリックの場合 ---
          if (this.clicked) {
            this.clicked = false;
            if (this.textEvent.isActive) return;
            const prevPhotoImage = CjTool.checkPhotoInFrame(imageArea);
            if (prevPhotoImage) {
              if (focusMode === 'scale' && (!this.targetFrame || this.targetFrame === imageArea)) {
                //　写真のフォーカスの形を整える
                const { scaleX: photoScale, originalBounds } = CjTool.getPhotoContainer(image);
                const { width, height } = originalBounds;
                const targetFocus = CjTool.getFocusContainer(_imageArea, CJ_CONTAINER_NAME.focus.rotate);
                const handleIcons = CjTool.getFocusHandleIcon(targetFocus);
                const lines = CjTool.getFocusLine(targetFocus);
                const displayPhotoScale = photoScale * wrapperScale;
                for (const icon of handleIcons) {
                  icon.scaleX = 1 / displayPhotoScale;
                  icon.scaleY = 1 / displayPhotoScale;
                }
                this.updateFocusLines(
                  lines,
                  { w: width * displayPhotoScale, h: height * displayPhotoScale },
                  { x: displayPhotoScale, y: displayPhotoScale },
                );
                this.imageEditableTool.imageMode(imageArea);
                UiManager.ins.emit('l->r:change-image/frame', { mode: 'image' });
              }
            }
            return;
          }
          // --- シングルクリックの場合 ---
          this.clicked = true;
          UiManager.ins.emit('l->r:show-tooltip', { type: 'none', pos: { x: 0, y: 0 } });
          // --- ダブルクリック受付時間 ---
          setTimeout(() => {
            // ---- ダブルクリックだとfalse ----
            if (this.clicked) {
              if (this.textEvent.isActive) return;
              if (focusMode === 'scale' && !imageArea.logoFlag) {
                this.handleFocus(imageArea, 'scale');
              }
            }
            this.clicked = false;
          }, 250);
        });

        // '「ダブルクリック」でトリミング'のツールチップ表示
        imageArea.addEventListener('mouseover', (e: any) => this.mouseOverEvent(e, image));
        imageArea.addEventListener('mouseout', (e: any) => this.mouseOutEvent(e, image));
      }
      // -- DnDイベント設定 --
      image.addEventListener('mousedown', (e: any) => {

        const focusMode = this.layoutDataManager.selector('getFocusMode');
        if (focusMode === 'move') {
          this.handleMoveStart(image, e);
          return;
        }
        const isPhoto = CjTool.checkPhotoInFrame(image);
        if (this.clicked || focusMode === 'rotate' || !this.isSelect || this.isFocus || !isPhoto) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        this.handleMoveStart(image, e);
      }, true);
      image.addEventListener('pressmove', (e: any) => {
        const focusMode = this.layoutDataManager.selector('getFocusMode');
        if (focusMode === 'move') {
          this.handleMove(image, e);
          return;
        }
        if (this.clicked || focusMode === 'rotate' || !this.isSelect || this.isFocus) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        this.handleMove(image, e);
      }, true);
      image.addEventListener('pressup', (e: any) => {
        const focusMode = this.layoutDataManager.selector('getFocusMode');
        if (focusMode === 'move') {
          this.handleMoveEnd(image, e);
          return;
        }
        if (focusMode === 'rotate' || !this.isSelect || this.isFocus) return;
        if (focusMode === 'png' && this.targetFrame) {
          this.editableEvent.disFocused(this.targetFrame);
        }
        this.handleMoveEnd(image, e);
      }, true);
    }
  }
}
